import { Component, OnChanges, Input, Output, EventEmitter } from "@angular/core";
import * as Moment from "moment";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";

@Component({
	selector: "app-raw-select",
	templateUrl: "./raw-select.component.html",
	styleUrls: ["./raw-select.component.scss"]
})
export class RawSelectComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	component: AssemblyConfig.Component;
	@Input()
	shaft: AssemblyConfig.Shaft | AssemblyConfig.MotorShaft;
	@Output()
	rawSelected = new EventEmitter();

	pairs: true;

	rawids: APIResults.RawSinglesResult[] | APIResults.RawPairsResult[] = [];
	selected: APIResults.RawSinglesResult | APIResults.RawPairsResult;

	selectedDate: string;
	allowedDates: NgbDateStruct[] = null;

	constructor(private api: ApiService) { }

	rawChange(raw: APIResults.RawSinglesResult | APIResults.RawPairsResult) {
		this.rawSelected.emit(raw);
	}

	dateChange() {
		this.refreshRaws();
	}

	async ngOnChanges() {
		this.allowedDates = null;
		// TODO: motor needs pairs now...?
		if (this.component.type === "tach" || this.component.type === "motorshaft" || this.component.type === "current" || this.component.type === "impact" || this.component.type === "sensor") {
			this.allowedDates = await this.api.GetComponentRawSingleDates(this.asset.asset_id, this.component.id);
		} else if (this.component.type === "motor" || this.component.type === "motorbearing") {
			this.allowedDates = await this.api.GetComponentRawSingleDates(this.asset.asset_id, this.shaft.id);
		} else if (this.component.type === "gear" || this.component.type === "bearing") {
			this.allowedDates = await this.api.GetComponentRawPairDates(this.asset.asset_id, this.shaft.id);
		} else {
			this.allowedDates = await this.api.GetComponentRawPairDates(this.asset.asset_id, this.component.id);
		}
		if (this.allowedDates && this.allowedDates.length) {
			this.selectedDate = DvsUtilities.FormatNgbDate(this.allowedDates[this.allowedDates.length - 1], null);
		}
		await this.refreshRaws();
	}

	async refreshRaws() {
		if (!this.selectedDate) return;
		const start = this.selectedDate;
		const end = Moment(this.selectedDate).add(1, "days").format("YYYY-MM-DD");
		this.rawSelected.emit(undefined);
		if (this.asset && this.component) {
			let getter: Promise<any>;

			if (this.component.type === "tach" || this.component.type === "motorshaft" || this.component.type === "current" || this.component.type === "impact" || this.component.type === "sensor") {
				getter = this.api.GetComponentRawSingles(this.asset.asset_id, this.component.id, start, end);
			} else if (this.component.type === "motor" || this.component.type === "motorbearing") {
				getter = this.api.GetComponentRawSingles(this.asset.asset_id, this.shaft.id, start, end);
			} else if (this.component.type === "gear" || this.component.type === "bearing") {
				getter = this.api.GetComponentRawPairs(this.asset.asset_id, this.shaft.id, start, end);
			} else {
				getter = this.api.GetComponentRawPairs(this.asset.asset_id, this.component.id, start, end);
			}
			try {
				const result = await getter;
				this.rawids = result;
				// Autoselect first (newest) raw
				if (result && result.length) {
					this.selected = result[0];
					this.rawChange(result[0]);
				}
			} catch (err) {
				console.error("Couldn't load tach raws");
				console.log(err);
				// TODO: Error handling
			}
		}
	}
}
